<template>
	<v-card flat>
		<v-list
			v-if="machines.length > 0"
			max-height="75vh"
			class="overflow-y-auto"
		>
			<v-list-item
				v-for="machinePivot in machines"
				:key="machinePivot.machine.id"
				class="justify-space-between px-0"
				style="min-height: 0 !important;"
			>
				<router-link
					:to="`/machines/${machinePivot.machine.id}`"
					class="text-decoration-none"
				>
					<b>{{ machinePivot.machine.vendor.name }}</b> {{ machinePivot.machine.model_name }}
				</router-link>

				<v-spacer/>

				<code v-if="machinePivot.vendor_code">{{ machinePivot.vendor_code }}</code>
			</v-list-item>
		</v-list>
		<v-card-text v-else>
			Деталь не используется ни в одной технике
		</v-card-text>
		<v-divider class="my-2"/>
		<v-autocomplete
			v-model="autocomplete.value"
			:search-input.sync="autocomplete.term"
			:items="autocomplete.items"
			placeholder="Добавить машину"
			item-text="full_name"
			item-value="id"
			autocomplete="off"
			return-object
			outlined
			dense
			hide-details
			@change="handleMachineSelected"
		/>
		<div v-show="form.machine !== null">
			<v-text-field
				v-model="form.vendorCode"
				name="vendor_code"
				label="Оригинальный артикул (необязательно)"
				class="mt-2"
				outlined
				dense
			/>
			<v-btn
				color="green"
				outlined
				@click="handleSubmit"
			>
				Сохранить
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue';

export default {
	name: 'ProductMachinesUsage',
	props: {
		machines: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		autocomplete: {
			value: null,
			term: '',
			items: [],
		},
		form: {
			machine: null,
			vendorCode: null,
		},
		submitted: false,
	}),
	watch: {
		'autocomplete.term'(v) {
			this.searchMachines(v);
		},
	},
	methods: {
		async searchMachines(term) {
			if (!term) {
				this.autocomplete.items = [];
				return;
			}
			const res = await Vue.prototype.$http.get('/api/v2/schemes/machines', {
				params: {
					filter: {
						search: term,
					},
				},
			});
			this.autocomplete.items = res.data.data;
		},
		handleMachineSelected(machine) {
			this.form.machine = machine;
		},
		handleSubmit(machine) {
			if (this.submitted) {
				return;
			}
			this.submitted = true;
			this.$emit('add-machine', Object.assign({}, this.form));
			this.autocomplete.term = '';
			this.autocomplete.items = [];
			this.autocomplete.value = null;
			this.form.machine = null;
			this.form.vendorCode = null;
			setTimeout(() => {
				this.submitted = false
			}, 1000);
		},
	},
};
</script>

<style scoped>

</style>
